module.exports = __webpack_public_path__ + "static/img/b5fed6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/qhRecommendOpenAccount/images/tittle.png
// module id = 681
// module chunks = 2